// extracted by mini-css-extract-plugin
export default {"birthdayWishContainer":"H0HdkSVndi","birthdayWishContainer_hasError":"byn9IkeeMe","birthdayWishInputWrapper":"MhA1wKzTBO","emojiButtonContainer":"YB41wUGmkf"};